import { Formik, Form, Field } from 'formik';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router';
import * as Yup from 'yup';
import { API_BASE_URL, API_URL, DEFAULT_PER_PAGE } from '../../utilities/constants';
import { handleApiCall } from '../../utilities/helper';
import { useUI } from '../../context/UI';

const AddDepartment = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const {
        setNewNotification,
        setShowNotification,
        addNotification,
        setSegmentTitle,
        addToastMessage,
    } = useUI();

    const initialValues = {
        departmentName: "",
        spreadPercentage: "",
    };
    const validationSchema = Yup.object().shape({
        departmentName: Yup.string().required('Department Name is required'),
    });

    const handleAddDepartments = async (value) => {
        setLoading(true);
        try {
            const payload = {
                departmentName: value.departmentName,
            };

            const response = await handleApiCall(API_BASE_URL + "/api/1.0.0/department", {
                method: "POST",
                body: payload,
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully created a Department, Thank You!",
                });
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully created a Department!",
                    status: true,
                    archive: false,
                });
                navigate(`/department?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`);
            }
            else {
                addToastMessage({
                    status: false,
                    message:
                        response?.responseDescription ||
                        "Something went wrong while creating a Department. Please try again!",
                });
            }
        } catch (e) {
            setNewNotification(true);
            setShowNotification(true);
            addNotification({
                id: Date.now(),
                message: "Something went wrong while creating a Department.",
                status: false,
                archive: false,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setSegmentTitle("Add Department");
    }, []);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}


            onSubmit={handleAddDepartments}
        >
            {({ errors, touched, setFieldValue, values }) => (
                <Form className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md max- mx-auto space-y-6">

                    <div>
                        <label className="block text-sm font-medium mb-1">Department Name</label>
                        <Field
                            name="departmentName"
                            type="text"
                            placeholder="Enter departmentName"
                            className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                ? "border-red-500 focus:ring-red-300"
                                : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                }`}
                        />
                        {errors.departmentName && touched.departmentName && (
                            <p className="text-xs text-red-500 mt-1">{errors.departmentName}</p>
                        )}
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end gap-3 pt-4">
                        <NavLink to='/department'>
                            <button
                                type="reset"
                                className="px-5 py-2 rounded-lg border border-gray-400 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700 transition"
                            >
                                Cancel
                            </button>
                        </NavLink>
                        <button
                            type="submit"
                            className="px-6 py-2 rounded-lg font-medium bg-brand-600 text-white hover:bg-brand-700 transition"
                        >
                            Submit
                        </button>
                    </div>
                </Form>
            )}
        </Formik>

    );
};
export default AddDepartment;


